import React from 'react';
import { useNavigate } from 'react-router-dom';
import AuthGate from './AuthGate';
import './PythonCurriculumPage.css';

/**
 * Full-page curriculum viewer with a back-to-desktop button and an AuthGate-wrapped iframe.
 */
const PythonCurriculumPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="curriculum-page">
      <div className="curriculum-header">
        <button className="curriculum-back" onClick={() => navigate('/')}>
          ← Back
        </button>
        <span className="curriculum-title">
          <img
            src="https://www.python.org/static/favicon.ico"
            alt=""
            width="16"
            height="16"
          />
          Python Index Curriculum
        </span>
      </div>
      <div className="curriculum-content">
        <AuthGate>
          <iframe
            className="curriculum-iframe"
            src="/python-index-curriculum-content/index.html"
            title="Python Index Curriculum"
          />
        </AuthGate>
      </div>
    </div>
  );
};

export default PythonCurriculumPage;
